import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a8496fbbedae70014cbcac4_1787593953269_b1b1434d/stocklot_1787074299193/src/app/dashboard/page.tsx");
